import Rails from '@rails/ujs';
import 'bootstrap';
import $ from 'jquery'; // eslint-disable-line
import '@nathanvda/cocoon';

import './common/change_circle_button';
import './common/clear_on_click';
import './common/copy_form_value';
import './common/data_link';
import './common/disable_on_checked';
import './common/disable_on_empty';
import './common/dont_see_more';
import './common/edit_message';
import './common/enable_on_change';
import './common/mirror_value_to';
import './common/modal_default_open';
import './common/nested_checkbox';
import './common/prevent_enter_submission';
import './common/scroll_to_bottom';
import './common/see_more';
import './common/show_file_list';
import './common/show_if_checked_any';
import './common/submit_on_change';
import './common/toggle_enable_on_checked';
import './lazy_loader/load_trix';
import './pages/checked_requests_count';
import './pages/decline_negotiation_action';
import './pages/disable_on_submit';
import './pages/job_preview';
import './pages/set_end_at_on_change';
import './pages/survey';

Rails.start();
